/** Giới hạn ký tự form lời chúc, dùng chung cho validate client và server action */
export const THE_MARTIAN_WISH_LIMITS = { name: 50, message: 300 }
